// extracted by mini-css-extract-plugin
export default {"clearSearch":"SearchField_clearSearch__CwNLK"};